module.exports = __webpack_public_path__ + "img/map_20.31189985.png";